import { toast } from 'react-toastify';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { getVCardStringWithPhoto, getVCardString } from '../../../../utils/vcard';
import { download } from '../../../../utils/download';
import Backend from '../../../../backend';
import { handleWalletPassFetch } from '../../../../utils/wallet-pass';
import NativeOrWeb from '../../../../utils/native';
import IconToast from '../../../../components/NewToast';

function isSelfHosted(url) {
  const nextHost = new URL(url).host;
  const currentHost = new URL(process.env.PUBLIC_URL).host;
  return nextHost === currentHost;
}

export function messageListener(history, onMessage, cases, userDetails, intl) {
  const back = event => {
    try {
      if (event.origin === process.env.LINKER_URL) {
        const data = event.data.data;

        if (onMessage) {
          onMessage(event.data.success, event.data);
        } else if (event.data.success) {
          if (cases && cases[event.data.code]) {
            cases[event.data.code](data);
          } else
            switch (event.data.code) {
              case 'SHARE':
                // console.log(' --- messageListener: --- SHARE MESSAGE REQUEST: ');
                // console.log(data);
                if (data.text) {
                  NativeOrWeb.copyToClipboard(data.text).then(() =>
                    toast.info(IconToast('info', intl ? intl.formatMessage({ id: 'Copied!' }) : 'Copied!'), {
                      className: 'new-toast'
                    })
                  );

                  NativeOrWeb.share({
                    title: data.title,
                    text: data.text,
                    url: data.url,
                    imageUrl: data.imageUrl,
                    imageCompression: data.imageCompression
                  });
                }
                break;
              case 'PUSH':
                // console.log(" --- messageListener: --- Redirect to PATH: ", data);
                if (data) {
                  history.push({ pathname: data });
                }
                break;
              case 'REDIRECT':
                // console.log(" --- messageListener: --- Redirect to PATH: ", data);
                if (data?.startsWith('http') || data?.startsWith('https')) {
                  if (isSelfHosted(data)) {
                    const url = new URL(data);
                    history.push({
                      pathname: url.pathname,
                      search: url.search
                    });
                  } else {
                    if (Capacitor.isNativePlatform()) {
                      Browser.open({ url: data });
                    } else {
                      window.open(data);
                    }
                  }
                } else if (data) {
                  history.push({ pathname: data });
                }
                break;
              case 'TOAST':
                toast.success(data);
                break;
              case 'DOWNLOAD_VCF_FILE':
                if (userDetails) {
                  if (userDetails.avatar) {
                    getVCardStringWithPhoto(userDetails, string =>
                      download(string, `${userDetails.name}.vcf`, 'text/x-vcard')
                    );
                  } else {
                    const vCardString = getVCardString(userDetails);
                    download(vCardString, `${userDetails.name}.vcf`, 'text/x-vcard');
                  }
                }
                break;
              case 'OPEN_IN_NEW_WINDOW':
                window.open(event.data.data, '_blank');
                break;
              case 'DOWNLOAD_APPLE_WALLET_ECARD':
                handleWalletPassFetch(Backend.methodUrl(`wallet-pass/apple?language=${event.data.data}`), 'apple');
                break;
            }
        }
      }
    } catch (e) {
      console.error('Error in messageListener:', e);
    }
  };
  window.addEventListener('message', back, false);
  return () => window.removeEventListener('message', back);
}
